import { CLEAR_POSTS } from '../actions/posts'

const posts = (state = {}, action = {}) => {
  switch (action.type) {
    case CLEAR_POSTS:
      state = {}
      break
  }
  return state
}

export default posts
